import React from "react";
import { Heart, Stethoscope, Users } from "lucide-react";

export default function About() {
  return (
    <section
      id="about"
      className="py-20 md:py-32 px-6 md:px-12 bg-brand-sand"
      data-testid="about-section"
    >
      <div className="max-w-7xl mx-auto grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
        <div className="lg:col-span-5">
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-brand-terracotta" data-testid="about-eyebrow">
            About the Clinic
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-brand-blue mt-4 leading-tight" data-testid="about-headline">
            Clinical care, delivered with warmth and patience.
          </h2>

          <div className="mt-8 rounded-3xl overflow-hidden shadow-lg" data-testid="about-image-wrap">
            <img
              src="https://customer-assets.emergentagent.com/job_senior-balance-rehab/artifacts/p74d16m1_ChatGPT%20Image%20Jun%2027%2C%202026%2C%2011_37_27%20AM.png"
              alt="Senior lady doing supervised dumbbell training with a Reading Physio physiotherapist at home"
              className="w-full h-auto block"
              data-testid="about-image"
            />
          </div>
        </div>

        <div className="lg:col-span-7 space-y-6 text-lg text-slate-700 leading-relaxed">
          <p data-testid="about-paragraph-1">
            The Fall and Frailty Prevention Clinic, part of Reading Physio, was founded on a simple belief: with the right
            programme, anyone can rebuild the strength, balance and confidence to move safely again. Whether
            you are recovering from injury or wanting to age strongly, our chartered physiotherapists guide
            every session — no generic exercises, no rushed appointments.
          </p>
          <p data-testid="about-paragraph-2">
            We blend evidence-based physiotherapy with progressive strength and mobility training in a calm,
            unhurried setting — delivering care both in our clinic in Reading and in patients&apos; homes across Berkshire.
          </p>

          <div className="grid sm:grid-cols-3 gap-6 pt-6">
            <div className="bg-white rounded-2xl p-6 border border-brand-clay" data-testid="about-card-1">
              <Stethoscope size={32} strokeWidth={1.5} className="text-brand-teal mb-4" />
              <h3 className="font-display text-xl text-brand-blue mb-2">Clinical depth</h3>
              <p className="text-base text-slate-600">Every plan written and supervised by a chartered physio.</p>
            </div>
            <div className="bg-white rounded-2xl p-6 border border-brand-clay" data-testid="about-card-2">
              <Heart size={32} strokeWidth={1.5} className="text-brand-terracotta mb-4" />
              <h3 className="font-display text-xl text-brand-blue mb-2">Designed Around You</h3>
              <p className="text-base text-slate-600">One-to-one sessions, patient-centred, tailored to your goals.</p>
            </div>
            <div className="bg-white rounded-2xl p-6 border border-brand-clay" data-testid="about-card-3">
              <Users size={32} strokeWidth={1.5} className="text-brand-gold mb-4" />
              <h3 className="font-display text-xl text-brand-blue mb-2">Built for seniors</h3>
              <p className="text-base text-slate-600">Equipment, pace and language designed for older adults.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
